import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Row } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { authCreators } from '../../../../auth/auth-action';
import { AuthHelper } from '../../../../auth/auth-helper';
import { AUTH_STATE_KEY, authStateSelector } from '../../../../auth/auth-reducer';
import { RBHBox, RBHImage, RBHText } from '../../../../shared/components';
import styleImage from '../../../../shared/components/rbh-image/styles';
import stylesText from '../../../../shared/components/rbh-text/styles';
import { Images } from '../../../../shared/theme';
import { mainCreators } from '../../../main-action';
import { BUSINESS_TYPE, SCREEN_TYPE } from '../../../main-constant';
import { MAIN_STATE_KEY, mainStateSelector } from '../../../main-reducer';
import styles from './styles';
import './styles.css';

export function MenuBar({ children }: any) {
  const dispatch = useDispatch();
  const history = useHistory();
  const email = useSelector(authStateSelector(AUTH_STATE_KEY.EMAIL));
  const headermunu = useSelector(mainStateSelector(MAIN_STATE_KEY.HEADER_MENU));
  const isMart = AuthHelper.getBusinessTypeId() === BUSINESS_TYPE.MART;

  function onMenu(screen: number) {
    switch (screen) {
      case SCREEN_TYPE.BRANCH_MANAGEMENT:
        history.push('/main/branchmanagement');
        dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, SCREEN_TYPE.BRANCH_MANAGEMENT));
        break;
      case SCREEN_TYPE.USER_MANAGEMENT:
        history.push('/main/usermanagement');
        dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, SCREEN_TYPE.USER_MANAGEMENT));
        break;
      case SCREEN_TYPE.VAT_ADDRESS:
        history.push('/main/vataddress');
        dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, SCREEN_TYPE.VAT_ADDRESS));
        break;
      case SCREEN_TYPE.CATEGORY:
        history.push(isMart ? '/main/martcategory' : '/main/foodcategory');
        dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, SCREEN_TYPE.CATEGORY));
        break;
      case SCREEN_TYPE.PRODUCT_MENU:
        history.push(isMart ? '/main/martproduct' : '/main/foodmenu');
        dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, SCREEN_TYPE.PRODUCT_MENU));
        break;
      case SCREEN_TYPE.REPORT:
        history.push('/main/report');
        dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, SCREEN_TYPE.REPORT));
        break;
      case SCREEN_TYPE.LOGOUT:
        dispatch(authCreators.logOut());
        dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 0));
        break;
      case SCREEN_TYPE.DEVICE_MANAGEMENT:
        history.push('/main/devicemanagement');
        dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 0));
        break;
      default:
        break;
    }
  }

  const menu = (
    <Menu>
      <Menu.Item key={'0'}>
        <a id={'deviceManagement-menu'} style={styles.menuItemBoxLogout} onClick={() => onMenu(SCREEN_TYPE.DEVICE_MANAGEMENT)}>
          <RBHText id={'deviceManagementMenu-text'} data-testid={'deviceManagementMenu-text'} style={stylesText.textTopMenuOff}
            text={'main.deviceManagement.menu.text'} />
        </a>
      </Menu.Item>
      <Menu.Item key={'1'}>
        <a id={'id-logout'} style={styles.menuItemBoxLogout} onClick={() => onMenu(SCREEN_TYPE.LOGOUT)}>
          <RBHText id={'id-logout-text'} data-testid={'id-logout-text'} style={stylesText.textTopMenuOff} text={'main.logout'} />
        </a>
      </Menu.Item>
    </Menu>
  );

  return (
    <RBHBox style={history.location.pathname === '/main' ? styles.landingLayout : styles.defaultLayout}>
      <RBHBox>
        <RBHBox style={history.location.pathname === '/main' ? styles.landingHeader : styles.defaultHeader}>
          <RBHBox style={styles.logoAndButtonContainer}>
            <RBHImage id={'id-top-menu-logo'} data-testid={'id-top-menu-logo'} style={styles.logo} src={Images.logoIcon}
              onClick={() => { history.push('/main'); }} />
            <RBHBox style={styles.menuBox}>
              <RBHBox style={headermunu === SCREEN_TYPE.BRANCH_MANAGEMENT ? styles.menuItemBoxOn : styles.menuItemBoxOff}>
                <a>
                  <RBHText id={'id-top-menu-branchmanagement'} data-testid={'id-top-menu-branchmanagement'}
                    onClick={() => onMenu(SCREEN_TYPE.BRANCH_MANAGEMENT)}
                    style={headermunu === SCREEN_TYPE.BRANCH_MANAGEMENT ? stylesText.textTopMenuOn : stylesText.textTopMenuOff}
                    text={'main.branchmanagement'}
                  />
                </a>
              </RBHBox>

              <RBHBox style={headermunu === SCREEN_TYPE.USER_MANAGEMENT ? styles.menuItemBoxOn : styles.menuItemBoxOff}>
                <a>
                  <RBHText id={'id-top-menu-usermanagement'} data-testid={'id-top-menu-usermanagement'}
                    onClick={() => onMenu(SCREEN_TYPE.USER_MANAGEMENT)}
                    style={headermunu === SCREEN_TYPE.USER_MANAGEMENT ? stylesText.textTopMenuOn : stylesText.textTopMenuOff}
                    text={'main.user.usermanagement'}
                  />
                </a>
              </RBHBox>

              <RBHBox style={headermunu === SCREEN_TYPE.VAT_ADDRESS ? styles.menuItemBoxOn : styles.menuItemBoxOff}>
                <a>
                  <RBHText id={'id-top-menu-vataddress'} data-testid={'id-top-menu-vataddress'}
                    onClick={() => onMenu(SCREEN_TYPE.VAT_ADDRESS)}
                    style={headermunu === SCREEN_TYPE.VAT_ADDRESS ? stylesText.textTopMenuOn : stylesText.textTopMenuOff}
                    text={'main.vat_vataddress'}
                  />
                </a>
              </RBHBox>

              <RBHBox style={headermunu === SCREEN_TYPE.CATEGORY ? styles.menuItemBoxOn : styles.menuItemBoxOff}>
                <a>
                  <RBHText id={'id-top-menu-foodcategory'} data-testid={'id-top-menu-category'}
                    onClick={() => onMenu(SCREEN_TYPE.CATEGORY)}
                    style={headermunu === SCREEN_TYPE.CATEGORY ? stylesText.textTopMenuOn : stylesText.textTopMenuOff}
                    text={'main.foodcategory'}
                  />
                </a>
              </RBHBox>

              <RBHBox style={headermunu === SCREEN_TYPE.PRODUCT_MENU ? styles.menuItemBoxOn : styles.menuItemBoxOff}>
                <a>
                  <RBHText id={'id-top-menu-foodmenu'} data-testid={'id-top-menu-foodmenu'}
                    onClick={() => onMenu(SCREEN_TYPE.PRODUCT_MENU)}
                    style={headermunu === SCREEN_TYPE.PRODUCT_MENU ? stylesText.textTopMenuOn : stylesText.textTopMenuOff}
                    text={'main.foodmenu'}
                  />
                </a>
              </RBHBox>

              <RBHBox style={headermunu === SCREEN_TYPE.REPORT ? styles.menuItemBoxOn : styles.menuItemBoxOff}>
                <a>
                  <RBHText id={'id-top-menu-report'} data-testid={'id-top-menu-report'}
                    onClick={() => onMenu(SCREEN_TYPE.REPORT)}
                    style={headermunu === SCREEN_TYPE.REPORT ? stylesText.textTopMenuOn : stylesText.textTopMenuOff}
                    text={'main.report'}
                  />
                </a>
              </RBHBox>
            </RBHBox>
          </RBHBox>
          <Row>
            <RBHImage
              id={isMart ? 'martBusinessIcon' : 'foodBusinessIcon'}
              style={styleImage.iconS}
              src={isMart ? Images.martIcon : Images.foodIcon}
            />
            <Dropdown overlay={menu} trigger={['click']}>
              <a id={'id-logout-box'} data-testid={'id-logout-box'} style={styles.boxLogout}>
                <RBHText id={'id-email-text'} style={stylesText.textTopMenuLogout}>{email}</RBHText>
                <DownOutlined id={'icon_dropdown'} translate={null} style={styles.dropdownImage} />
              </a>
            </Dropdown>
          </Row>
        </RBHBox>
        <RBHBox style={history.location.pathname === '/main' ? styles.landingContent : styles.defaultContent}>
          {children}
        </RBHBox>
      </RBHBox>
    </RBHBox>

  );
}
